import { Save, X } from 'lucide-react'
import { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { fileToBase64 } from 'utils/file-to-base64'
import { formatDate } from 'utils/FormatDate'
import { showHttpToast } from 'lib/show-toast'
import { PapeletaService } from '../services/papeleta.service'
import { Spinner } from 'components/ui/spinner'

export function PapeletaUploadForm({ id, onSuccess, onCancel }) {
    const [file, setFile] = useState(null)
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (id) {
            setLoading(true)
            const error = validateFile(file)
            if (error) {
                setError(error)
            } else {
                const base64 = await fileToBase64(file)
                const filename =
                    file.name.slice(0, file.name.length - 4) + '-' + formatDate(new Date(), 'YmdHi')
                const { success, message, errors } = await PapeletaService.upload(id, {
                    file: base64,
                    filename,
                })
                showHttpToast(success, { description: message })
                if (success) {
                    onSuccess?.()
                } else {
                    if (errors?.file) setError(errors.file)
                }
            }
            setLoading(false)
        }
    }
    const handleChange = (e) => {
        setFile(e.target.files?.[0] ?? null)
        if (error) setError('')
    }

    return (
        <form onSubmit={handleSubmit} className='space-y-4'>
            <div className='px-3 py-2'>
                <div>
                    <label className='form-label'>Archivo</label>
                    <Form.Control
                        type='file'
                        accept='.pdf'
                        onChange={handleChange}
                        isInvalid={!!error}
                    />
                    <div className='invalid-feedback'>{error}</div>
                </div>
            </div>
            <div className='text-end space-x-2 px-3 py-2 border-top'>
                <Button variant='outline-primary' onClick={onCancel}>
                    <X className='size-4' />
                    Cancelar
                </Button>
                <Button type='submit' disabled={loading}>
                    {loading ? <Spinner /> : <Save className='size-4' />}
                    Guardar
                </Button>
            </div>
        </form>
    )
}

const validateFile = (file) => {
    if (!file) return 'Requerido'
    if (file.type !== 'application/pdf') {
        return 'Formato de archivo no valido'
    }
    return ''
}
